export const BLOCK_NUMBER_FIRST = 1;
export const BLOCK_NUMBER_THIRD = 3;
export const BLOCK_NUMBER_FOURTH = 4;
